import { useState } from 'react';
import { components } from 'react-select';

import { Icon, IconDrawEnum, OptionType, Select } from '@indicia/component-library';

import SurveyAnswer from '../../../../shared/models/survey/SurveyAnswer';
import SurveyChoiceOption from '../../../../shared/models/survey/SurveyChoiceOption';
import { SurveyMultipleChoiceQuestionType } from '../SurveyQuestionTypes';

import '../SurveyQuestion.scss';

type PropType = SurveyMultipleChoiceQuestionType & {
  id: string;
  onAnswerSelect: (answer: SurveyAnswer) => void;
  options: SurveyChoiceOption[];
  bem: (element: string | null, modifier: string | null, condition: boolean) => string;
  previousAnswer: string[];
};

const { Option } = components;
const SelectOption = (props: any) => {
  const {
    data: { label },
  } = props;

  return (
    <Option {...props}>
      {label}
      <Icon
        name="checkmark"
        draw={IconDrawEnum.Fill}
        width={14}
        height={14}
      />
    </Option>
  );
};

const SurveyDropdownQuestion = ({ bem, id, options, onAnswerSelect, previousAnswer }: PropType) => {
  const [selectedAnswers, setSelectedAnswers] = useState<string[]>(previousAnswer || []);

  const selectOptions: OptionType[] = options.map(({ id: value, description: label }) => ({
    value,
    label,
  }));

  const onChangeHandler = ({ value }: OptionType) => {
    const index = selectedAnswers.indexOf(value);
    let answers: string[] = [];
    if (index !== -1) {
      answers = [];
    } else {
      answers = [value];
    }

    setSelectedAnswers(answers);
    onAnswerSelect({
      value: answers,
      questionId: id,
    });
  };

  return (
    <div className={bem('answers', null, true)}>
      <div className={bem('dropdown', null, true)}>
        <Select
          options={selectOptions}
          onChange={(option: any) => onChangeHandler(option as OptionType)}
          menuPlacement="bottom"
          components={{ Option: SelectOption }}
          defaultValue={selectOptions.filter((option) => selectedAnswers.includes(option.value))}
        />
      </div>
    </div>
  );
};

export default SurveyDropdownQuestion;
